<script>
    import PageNavigation from './PageNavigation';

    export default {
        props: {
            app: {required: true, type: Object},
            admin: {required: true, type: Object},
        },
        components: {PageNavigation},
        provide() {
            return {
                adminListLayoutView: this
            };
        },
        computed: {
            pages() {
                return [this.admin.getListPage(), ...this.admin.getListPage().getCustomPages()];
            }
        }
    };
</script>
<template>
    <page-layout>
        <page-navigation :pages="pages"></page-navigation>
        <!-- Use $route.path (not fullPath) to avoid remounting on query-param changes (sort, page, search) -->
        <router-view :key="$route.path"></router-view>
    </page-layout>
</template>
